import { KYMW2400Model } from '../kymw2400.model';
import { PageTemplateModel } from '../vo/page-template.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページテンプレート新規登録コマンド。
 * 指定された情報で新規テンプレートを登録する。
 *
 * @export RegistNewTemplateService
 * @class RegistNewTemplateService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistNewTemplateService extends PlessJsonResponderSub<any> {

  private model: KYMW2400Model = null;
  private vo: PageTemplateModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistNewTemplateService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        PageTemplate: {
          condition: {
            MediaGroup: this.vo.mediaGroup,
            PageTemplateName: this.vo.pageTemplateName ?
              this.vo.pageTemplateName[0] : this.vo.pageTemplateName,
            PageAreaX: this.vo.pageAreaX,
            PageAreaY: this.vo.pageAreaY,
            PageAreaWidth: this.vo.pageAreaWidth,
            PageAreaHeight: this.vo.pageAreaHeight,
            DivW: this.vo.divW,
            DivH: this.vo.divH
          },
          combination: this.vo.sectionList.map(sectionVO => {
            return {
              condition: {
                SectionTemplateName: sectionVO.sectionTemplateName,
                PositionX: sectionVO.percentPositionX,
                PositionY: sectionVO.percentPositionY,
                Width: sectionVO.percentWidth,
                Height: sectionVO.percentHeight,
                DivW: sectionVO.divW,
                DivH: sectionVO.divH
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW2400Model} model モデルクラス
   * @param {PageTemplateModel} vo パラメータ
   * @memberof RegistNewTemplateService
   */
  execute(model: KYMW2400Model, vo: PageTemplateModel) {
    this.model = model;
    this.vo = vo;
    this.send('registNewTemplate', this.getBody());
    this.model.clearTemplateList();
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistNewTemplateService
   */
  success(data: any) {
    this.model.updatePageTemplateList(data);
  }
}
